<template>
  <div>
    <div class="card softblue">
      <div class="card-body">
        <div class="media">
          <img :src="userInfo.picture_path ? userInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
          <div class="media-body">
            <span class="badge rose">학생</span>
            <h5>{{userInfo.name}}</h5>
            <span>{{userInfo.school_name}} {{userInfo.id}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body gray">
      <h5>회원탈퇴</h5>
      <hr />
      <div class="agree-text">
        <ul>
          <li> - 해당 ID로 한달 동안은 재가입이 불가능합니다.</li>
          <li> - 회원정보 및 응시한 시험 정보가 삭제되며, 복구는 불가능합니다.</li>
        </ul>
      </div>
      <div class="agree-check">
        <el-checkbox v-model="checked" label="1">회원탈퇴 내용에 동의합니다.</el-checkbox>
      </div>
    </div>

    <div class="mypage-button">
      <button type="button" class="btn gray" @click="cancleUser">취소</button>
      <button type="button" class="btn mint" @click="withdrawUser" :disabled="!checked">회원탈퇴</button>
    </div>
  </div>

</template>

<script>

import common from '@/modules/common'

export default {
  name: 'S990102',
  mixins: [common.mixins],
  data () {
    return {
      checked: false,
      userInfo: {
        picture_path: '',
        name: '',
        id: '',
        school_name: '',
        msg_type: ''
      }
    }
  },
  created () {
    this.loadUserInfo()
  },
  methods: {
    loadUserInfo () {
      common.axios.get('/user/load/' + this.$store.getters.user_seq)
        .then(response => {
          const result = response.data
          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
        })
    },
    withdrawUser: function () {
      this.$confirm('회원을 탈퇴하시겠습니까?', '', {
      }).then(() => {
        common.axios.put('/user/withdraw', {user_info_seq: this.$store.getters.user_seq, msg_type: 'N'})
          .then(response => {
            if (response.data.status === 1) {
              this.$alert('회원 탈퇴가 정상적으로 처리되었습니다.', '', {
                showClose: false,
                callback: action => {
                  this.$store.dispatch('AUTH_LOGOUT').then(() => {
                    this.$router.push({name: 'LOGIN_S'})
                  })
                }
              })
            } else {
              this.$message.error(response.data.message)
            }
          })
      }).catch(() => {})
    },
    cancleUser () {
      this.$router.push({name: 'MAIN_S'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/S990102.vue